import { render } from "./stronaBlog.vue?vue&type=template&id=d419a0fe&scoped=true"
const script = {}

import "./stronaBlog.vue?vue&type=style&index=0&id=d419a0fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d419a0fe"]])

export default __exports__